import { IconButton, Tooltip } from '@mui/material';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { type FC } from 'react';

interface Props {
  fontSize?: string;
}
const defaultProps = { fontSize: '25px' };

const OpenSourceButton: FC<Props> = ({ fontSize }) => (
  <>
    <Tooltip title="Open source">
      <IconButton size="small" aria-label="Open">
        <span style={{ fontSize }}>
          <Icon iconId="open-external" />
        </span>
      </IconButton>
    </Tooltip>
  </>
);

OpenSourceButton.defaultProps = defaultProps;

export default OpenSourceButton;
